export const env = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? "http://127.0.0.1:54321",
  supabaseKey: import.meta.env.VITE_SUPABASE_ANON_KEY ?? "",
  environment: import.meta.env.VITE_ENVIRONMENT ?? "dev",
  appVersion: "1.0.0",
  // Owner's decision 37 (BD-160): the region the server functions run in, beside the database (set at build: eu-west-2
  // for the test project); empty leaves the choice to the platform.
  functionsRegion: import.meta.env.VITE_FUNCTIONS_REGION ?? ""
};
/** The headers that run a server function in the database's region (decision 37). */
export const regionHeaders = (): Record<string, string> => (env.functionsRegion ? { "x-region": env.functionsRegion } : {});
export const functionsUrl = (path: string) => `${import.meta.env.VITE_FUNCTIONS_URL ?? env.supabaseUrl}/functions/v1/${path.replace(/^\//, "")}`;

// Lets end-to-end tests call the same endpoints as the app.
if (typeof window !== "undefined") (window as unknown as { __RK_FUNCTIONS_URL__: string }).__RK_FUNCTIONS_URL__ = import.meta.env.VITE_FUNCTIONS_URL ?? env.supabaseUrl;
